import type { Subscription } from '../plans/types'
import type { RenewTarget } from './AssignPlanModal'

/**
 * What the Renew action needs for this plan, or null when it cannot be renewed:
 * it is not running (or frozen), has no end date, or a renewal is already queued.
 */
export function renewTargetFor(sub: Subscription | null, hasUpcoming: boolean): RenewTarget | null {
  if (!sub || hasUpcoming || sub.is_addon || !sub.expires_at) return null
  if (sub.effective_status !== 'active' && sub.effective_status !== 'frozen') return null
  return {
    subscriptionId: sub.id,
    gymPlanId: sub.gym_plan_id,
    planName: sub.gym_plans?.name ?? '',
    expiresAt: sub.expires_at,
    offerPercent: sub.renewal_offer?.percent ?? null,
  }
}
